import { useMemo, useState } from 'react';

import type { HeldBackFields } from '@/routes/shared/ProviderConfig/ProviderSchemaField';

/** The fields of one card whose editors hold their marks back, and the setter they report to. */
export function useHeldBackFields(): { heldBack: ReadonlySet<string>; fields: HeldBackFields } {
    const [heldBack, setHeldBack] = useState<ReadonlySet<string>>(() => new Set());
    const fields = useMemo<HeldBackFields>(
        () => ({
            setHeld: (name, held) =>
                setHeldBack((current) => {
                    if (current.has(name) === held) return current;
                    const next = new Set(current);
                    if (held) next.add(name);
                    else next.delete(name);
                    return next;
                }),
        }),
        []
    );
    return { heldBack, fields };
}
